import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isOpen: false,
  title: '',
  text: '',
  isPaymentFailed: false
};

export const notificationSlice = createSlice({
  name: 'notification',
  initialState,
  reducers: {
    openNotification(state, { payload: { title, text } }) {
      state.isOpen = true;
      state.title = title;
      state.text = text;
      state.isPaymentFailed = true;
    },
    closeNotification(state) {
      state.isOpen = false;
      state.title = '';
      state.text = '';
      state.isPaymentFailed = false;
    }
  }
});

export const { openNotification, closeNotification } = notificationSlice.actions;

export default notificationSlice.reducer;
